// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:08:34

export default {
  "id": "bloom-sort-2-bee-puzzle",
  "slug": "bloom-sort-2-bee-puzzle",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/41684a9791e24400b08222bf41383d70-512x384.jpeg",
  "gameUrl": "https://html5.gamedistribution.com/41684a9791e24400b08222bf41383d70/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Bloom Sort 2: Bee Puzzle",
      "description": "Dive into the enchanting world of Bloom Sort 2: Bee Puzzle, where flowers bloom, bees buzz, and your mind gets a delightful workout! This unique 3D puzzle game combines stunning 2D and 3D graphics with a relaxing, chill vibe, making it the perfect escape for players of all ages.",
      "instructions": "Embark on an endless adventure of sorting, matching, and blooming flowers in a garden. Experience the joy of connecting colorful flowers and creating beautiful patterns while you unwind from the stresses of everyday life.",
      "genres": [
        "Jigsaw"
      ],
      "tags": [
        "10x10"
      ]
    },
    "zh-CN": {
      "title": "绽放排序2：蜜蜂拼图",
      "description": "深入迷人的Bloom Sort 2：蜜蜂拼图世界，那里花朵绽放，蜜蜂嗡嗡作响，你的大脑也能得到愉快的锻炼！这款独特的3D拼图游戏将令人惊叹的2D和3D图形与轻松愉快的氛围相结合，成为所有年龄段玩家完美的逃避方式。",
      "instructions": "踏上无尽的冒险之旅，在花园中整理、匹配和绽放花朵。在放松日常生活的压力的同时，体验连接五彩花朵、创造美丽图案的乐趣。",
      "genres": [
        "拼图"
      ],
      "tags": [
        "10x10"
      ]
    },
    "zh-TW": {
      "title": "Bloom Sort 2: 蜜蜂拼圖",
      "description": "墮入Bloom Sort 2: Bee Puzzle迷人的世界中，花朵盛開，蜜蜂嗡嗡飛舞，讓你的大腦享受一段愉快的運動！這款獨特的3D益智遊戲結合了壯觀的2D和3D圖形與放鬆的風格，成為各年齡層玩家理想的逃避選擇！",
      "instructions": "啟航於無盡的種植、匹配及花朵盛開冒險之旅。在放鬆日常壓力的同時，體驗連接彩繽花朵和創造美麗圖案帶來的快樂。",
      "genres": [
        "拼圖"
      ],
      "tags": [
        "10x10"
      ]
    },
    "zh-HK": {
      "title": "綻放排序2：蜂蟻謎題",
      "description": "投入迷人的 Bloom Sort 2: Bee Puzzle 玩樂世界，花開鳥鳴，心思得著愉悅運動！這款獨特的 3D 盡智遊戲結合驚艷的 2D 及 3D 圖像，帶來輕鬆寧靜的氣氛，是適合各齡段玩家的完美避世之地。",
      "instructions": "踏上無盡的遊戲冒險，整理、匹配和開放花園中的花朵。在放鬆日常壓力的同時，體驗連接五彩繽紛的花朵，創造美麗圖案的樂趣。",
      "genres": [
        "謎片"
      ],
      "tags": [
        "10x10"
      ]
    },
    "ja": {
      "title": "ブルームソート2：ハチパズル",
      "description": "花が咲き、蜂が鳴る魅惑的な世界にダイブして、Bloom Sort 2: Bee Puzzleで楽しい脳トレを体験しよう！このユニークな3Dパズルゲームは、美しい2Dと3Dグラフィックを融合させ、リラックスした、リラックスした雰囲気を持っており、どの年齢層のプレイヤーにも最適な脱出ゲームです。",
      "instructions": "無限の冒険に参加し、園で花を整理し、一致させ、咲かせる。日常のストレスから解放される間に、色とりどりの花を結びつけ、美しいパターンを作る喜びを体験してください。",
      "genres": [
        "ジグソー"
      ],
      "tags": [
        "10x10"
      ]
    },
    "ko": {
      "title": "블루ーム 정렬 2: 벌 퍼즐",
      "description": "봄솟음 2: 벌 퍼즐의 매혹적인 세계로 떨어져 보세요. 꽃이 피고 벌이 지저귀며, 마음이 즐겁게 운동하는 것을 느낄 수 있습니다! 이 독특한 3D 퍼즐 게임은 장대한 2D와 3D 그래픽을 결합하여 편안하고 취미적인 분위기를 자아내며, 모든 연령대의 플레이어에게 완벽한 탈출용 게임입니다.",
      "instructions": "불가능한 모험에 떠나세요. 정리하고, 일치시키고, 꽃을 피우는 정원에서. 일상의 스트레스에서 쉬고, 다양한 꽃을 연결하여 아름다운 패턴을 만드는 즐거움을 경험하세요.",
      "genres": [
        "조이스틱"
      ],
      "tags": [
        "10x10"
      ]
    },
    "fr": {
      "title": "Tri des Fleurs 2 : Puzzle de l'Abeille",
      "description": "Plongez dans le monde enchanté de Bloom Sort 2: Bee Puzzle, où les fleurs s'épanouissent, les abeilles bourdonnent et votre esprit se voit offert un entraînement délicieux ! Ce jeu de puzzle unique en 3D combine des graphismes époustouflants en 2D et 3D avec une ambiance apaisante et chill, en devenant le parfait havre de paix pour les joueurs de tous âges.",
      "instructions": "Embarkez sur une aventure infinie de tri, de correspondance et de floraison des fleurs dans un jardin. Profitez du bonheur de connecter des fleurs colorées et de créer des motifs beaux tout en vous détendant des stresses du quotidien.",
      "genres": [
        "Puzzle en morceaux"
      ],
      "tags": [
        "10x10"
      ]
    }
  }
};
